export const UPDATE_WEBHOOK = 'licensee/update-webhook';
export const UPDATE_WEBHOOK_SUCCESS = 'licensee/update-webhook-success';
export const UPDATE_WEBHOOK_FAIL = 'licensee/update-webhook-fail';

export const UPDATE_WEBHOOK_CAMPAIGN = 'licensee/update-webhook-campaign';
export const UPDATE_WEBHOOK_CAMPAIGN_SUCCESS = 'licensee/update-webhook-campaign-success';
export const UPDATE_WEBHOOK_CAMPAIGN_FAIL = 'licensee/update-webhook-campaign-fail';